import { makeEnum } from '../../utils';

const types = {
  PRIVATE_FOR_PROFIT: 'Private for-profit',
  PRIVATE_NON_PROFIT: 'Private nonprofit',
  PUBLIC: 'Public',
};
export const CollegeType = makeEnum(types);

const filterWeights = {
  MUST: 'MUST',
  NICE: 'NICE',
};
export const FilterWeight = makeEnum(filterWeights);

const filterOperators = {
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
};
export const FilterOperator = makeEnum(filterOperators);

const kinds = {
  STANDARD: 'Standard (4 year)',
  GRADUATE_SCHOOL: 'Graduate School',
  COMMUNITY_COLLEGE: 'Community College',
  VOCATIONAL_TECHNICAL: 'Vocational/Technical',
};
export const CollegeKind = makeEnum(kinds);

const surroundings = {
  REGIONAL_CITY: 'Located in a regional city',
  WITHIN_15_MILES_OF_REGIONAL_CITY: 'Located within 15 miles of a regional city',
  RURAL_TOWN: 'Located in a rural town',
  WITHIN_15_MILES_OF_RURAL_TOWN: 'Located within 15 miles of a rural town',
  WITHIN_MAJOR_URBAN_AREA: 'Located within a major urban area',
  WITHIN_15_MILES_OF_MAJOR_URBAN_AREA: 'Located within 15 miles of a major urban area',
  REGIONAL_TOWN: 'Located in a regional town',
  RURAL_AREA_15_MILES_FROM_TOWN: 'Located in a rural area 15 miles from a town',
};
export const CampusSurroundings = makeEnum(surroundings);

const sportGenders = {
  MALE: 'male',
  FEMALE: 'female',
  COED: 'coed',
};
export const SportGender = makeEnum(sportGenders);

const sportLevels = {
  VARSITY: 'VARSITY',
  CLUB: 'CLUB',
  INTRAMURAL: 'INTRAMURAL',
};
export const SportLevel = makeEnum(sportLevels);

const coedStatuses = {
  MEN_ONLY: 'Men Only',
  MEN_AND_WOMEN: 'Men and Women',
  WOMEN_ONLY: 'Women Only',
};
export const CoedStatus = makeEnum(coedStatuses);

export const ApplicationDeadlineType = {
  REGULAR: 'Regular',
};

export const TransferApplicationDeadlineType = {
  OTHER: 'Other',
};

export const FilterCompositionOperator = {
  AND: 'AND',
  OR: 'OR',
};

const distanceLearning = {
  NO: 'No distance learning opportunity',
  SOME: 'Some distance learning opportunity',
  ALL_PROGRAMS: 'All programs offered completely via distance education',
};
export const DistanceLearning = makeEnum(distanceLearning);

const acceptsIBCredits = {
  CREDIT: 'Credit',
  PLACEMENT: 'Placement',
  CREDIT_AND_OR_PLACEMENT: 'Credit and/or placement',
  NEITHER: 'Neither',
  UNKNOWN: 'Unknown',
};
export const AcceptsIBCredits = makeEnum(acceptsIBCredits);

export const AcademicMatch = {
  MATCH: 'MATCH',
  SAFETY: 'SAFETY',
  REACH: 'REACH',
};

export const TestScore = {
  ACT: 'ACT',
  SAT: 'SAT',
};

const admissionPolicy = {
  OPEN: 'Open admissions policy',
  COMPETITIVE: 'Competitive admissions policy',
  ROLLING: 'Rolling admissions policy',
  NO: 'No admissions policy',
};
export const AdmissionPolicy = makeEnum(admissionPolicy);

// enum values match the value of the "name" property in a list item of
// "special_service.field_he_specialserviceid_ref.he_special_services_id_ref.field_he_special_services_id_ref"
export const SpecialServices = makeEnum({
  ACADEMIC_CAREER_COUNSELING: 'Academic/Career Counseling',
  ASPERGERS_AUTISM: 'Aspergers/Autism Support Services',
  HEARING_IMPAIRED: 'Assistance for Hearing Impaired',
  PHYSICAL_ACCESSIBILITY: 'Assistance for Mobility Impaired',
  BLIND_VISUALLY_IMPAIRED: 'Assistance for Visually Impaired',
  DAY_CARE: 'Day Care Services',
  ESL_SERVICES: 'ESL (English as Second Language)',
  LEARN_DIFFERENCES: 'LD Specialists',
  TUTORING_SERVICES: 'Peer Tutors',
  REMEDIAL_SERVICES: 'Remedial Services',
  STUDY_ABROAD: 'Study Abroad',
});
